<template>
    <div class="TheConfirmation__mask" v-on:click.self="hide()" v-once>
        <div class="TheConfirmation">
            <div class="TheConfirmation__body">
                {{translate(title)}}
            </div>
            <div class="TheConfirmation__bottom">

                <!--CANCEL-->
                <BaseButtonFlat :label="'COMMON__CANCEL'"
                                @click="hide()" />

                <!--YES-->
                <BaseButton :label="'COMMON__YES'"
                            :accent="true"
                            @click="ok($event.target)" />

            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import BaseButton from './BaseButton.vue';
    import BaseButtonFlat from './BaseButtonFlat.vue';

    export default {
        name: 'TheConfirmation',
        components: {
            BaseButton,
            BaseButtonFlat
        },
        computed: {
            ...mapState({
                title: s => s.confirmation.title
            })
        },
        methods: {
            ...mapActions({
                hide: 'confirmation/hide',
                ok: 'confirmation/ok'
            })
        }
    };
</script>

<style>
    .TheConfirmation__mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        background-color: rgba(0, 0, 0, .5);
        -webkit-transition: opacity .3s ease;
        transition: opacity .3s ease;
    }

    .TheConfirmation {
        width: 95%;
        max-width: 400px;
        margin-top: 70px;
        padding: 10px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        -webkit-transition: all .3s ease;
        transition: all .3s ease;
    }

    .TheConfirmation__body {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 16px;
    }

    .TheConfirmation__bottom {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 16px 16px 0 16px;
    }

</style>



// WEBPACK FOOTER //
// TheConfirmation.vue?4e127b30